
import { Output, EventEmitter, Injectable } from '@angular/core';

import { TimeLineDay }   from './time-line-day';
import { TimeLineWeek }  from './time-line-week';
import { TimeLineMonth } from './time-line-month';

@Injectable()
export class TimeLine  { 
   
    justMine: Boolean   = false;
    menuIsOpen: Boolean = false;
    searchTerm: String  = new String();
    currentActivityState: String;

    year: number;
    day: TimeLineDay;
    week: TimeLineWeek; 
    month: TimeLineMonth; 

    years: number[];
    months: TimeLineMonth[];

    @Output() dateSelected: EventEmitter<any> = new EventEmitter();   
   
    constructor () {
    }

    init(): void {

        if (this.day != undefined) {
            
            this.dateSelected.next(this.day);
            return;
        }        

        const date  = new Date();
        this.year = date.getFullYear();

        this.years = [];

        for (let i = this.year - 10; i <= this.year + 10; i++) {

            this.years.push(i);
        }    

        this.createMonthsList(date);
        this.createMonthDays(date)
    }

    setDay(day: TimeLineDay) {

        this.day  = day;
        const m     = day.date.getMonth() ;

        if (m  !== this.month.id) {

            const month = this.months.find((item) => item.id === m)
            this.setMonth(month)
        }

        this.week = this.month.weeks
            .find((w) => w.id === this.day.week)  

        this.dateSelected.next(this.day);
    } 

    setToday() : void {

        this.day = null;
        this.init();
    }

    createDay(date: Date): TimeLineDay {

        const day = new TimeLineDay();

        day.date = date
        day.week = this.getWeek(date);    

        day.dayOfWeek = day.date.getDay();     

        return day;
    }

    isSelectedDay(d: TimeLineDay): Boolean {

        if (this.day === undefined)
            return false;
            
        return (d.date.getTime() 
            === this.day.date.getTime())
    }

    getWeek(date: Date): number {
   
        const onejan = new Date(date.getFullYear(), 0, 1);

        return Math.ceil( (( (date.getTime() - onejan.getTime())  / 86400000) + onejan.getDay())/7);
    }    

    setYear(year: number) {

        this.year = year;

        const newDate = new Date(year, 
            this.day.date.getMonth(), this.day.date.getDate());

        this.createMonthsList(newDate);
        this.createMonthDays(newDate)
    } 
    decreaseYear(): void {

        this.setYear(--this.year);
    }    
    increaseYear(): void {

        this.setYear(++this.year);
    }

    setMonth(month: TimeLineMonth) {

        this.month = month;

        const  date = new Date( 
            month.date.getFullYear(), month.id, this.day.date.getDate());

        this.createMonthDays(date);
    } 
    decreaseMonth(): void {

        const month = this.months.find(
            (item) => item.id === (this.month.id-1));

        if (month)
            this.setMonth(month);
    }    
    increaseMonth(): void {

        const month = this.months.find(
            (item) => item.id === (this.month.id+1));

        if (month)
            this.setMonth(month);
    }    

    createMonthDays(date: Date): void {

        const lastDate    = this.month.lastDate;
        const yearCurrent = this.month.date.getFullYear();

        if (this.month.hasDays){

            this.setDay(this.createDay(
                new Date(yearCurrent, this.month.id, date.getDate())));

            return;
        }

        let currentDay: TimeLineDay;
        for (let d = 1; d <= lastDate.getDate(); d++) {

            const day   = this.createDay(new Date(yearCurrent, this.month.id, d));
            day.month = this.month;

            if (date.getDate() === day.date.getDate())
                currentDay = day;

            const week  = this.month.weeks.find((w) => w.id === day.week)
            week.days.push(day);
        } 
        
        this.fillIncompleteWeeks(); 

        this.setDay(currentDay);
        this.month.hasDays = true; 
    }
    createMonthsList(date: Date): void {

        const yearCurrent = date.getUTCFullYear();

        // months list
        this.months = [];

        for (let i = 0; i < 12; i++) {

            const month = new TimeLineMonth()

            month.id   = i;
            month.date = new Date(date.getFullYear(), i, 1)

            const lastDay = 32 - new Date(yearCurrent, i, 32).getDate(); 
            month.lastDate = new Date(yearCurrent,  i, lastDay);

            month.hasDays = false; 

            // weeks for month
            month.weeks = [];
            for (let w = this.getWeek(month.date); w <= this.getWeek(month.lastDate); w++) {

                const week  = new TimeLineWeek();
                week.id   = w;
                week.days = [];

                month.weeks.push(week);
            }            

            this.months.push(month);
            if (month.id == date.getMonth()) {

                this.month = month;
            }
        }
    } 

    fillIncompleteWeeks() : void {

        this.month.weeks.forEach(w => {

            if (w.days.length < 7) {

                let day = w.days[0];

                if (w.id === this.month.weeks[0].id) {

                    for (let i = 1; i < day.dayOfWeek; i++) {

                        const missingDate = new Date(day.date.getTime());
                        missingDate.setDate(missingDate.getDate() - i);

                        w.days.unshift(this.createDay(missingDate));
                    }
                }
                else {

                    day = w.days[w.days.length-1];

                    for (let i = 1; i <= (7-day.dayOfWeek); i++) {

                        const missingDate = new Date(day.date.getTime());
                        missingDate.setDate(day.date.getDate() + i);

                        w.days.push(this.createDay(missingDate));
                    }
                }
            }
        });
    }

    // calculatePendingActivitiesDays(): void {

    //     // days with open activities
    //     let initialDate: String = this.month.date.getFullYear() + "/" + 
    //         (this.month.date.getMonth() + 1) + "/" + this.month.date.getDate();
            
    //     let finalDate: String   = this.month.lastDate.getFullYear() + "/" + 
    //         (this.month.lastDate.getMonth() + 1) + "/" +this.month.lastDate.getDate();

    //     this.service
    //         .getActivitiesDays(
    //             initialDate, 
    //             finalDate)
    //         .subscribe(days =>  {

    //             this.month.weeks.forEach(week => {

    //                 week.days.forEach(day => {

    //                     day.hasActivities = ( days.indexOf(day.date.getDate()) >= 0 && day.month === this.month) 
    //                 });                    
    //             });
    //         });
    // }
}
